import PatientResponsibleContainer from "./PatientResponsibleFormContainer";

export default PatientResponsibleContainer;
